<template>
  <b-card-code title="Form Pengajuan Cuti">
    <validation-observer ref="simpleRules">
      <b-form>
        <b-row>
          <!--  This field is required-->
          <b-col md="6">
            <b-form-group>
              <label>Nama</label>
              <validation-provider
                #default="{ errors }"
                name="First Name"
              >
                <b-form-input
                  v-model="biodata.nama"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Nama"
                  :disabled="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!--Enter Number between 10 & 20 -->
          <b-col md="6">
            <b-form-group>
              <label>NIP / NUP</label>
              <validation-provider
                #default="{ errors }"
                name="NIP / NUP"
                
              >
                <b-form-input
                  v-model="biodata.nip"
                  :state="errors.length > 0 ? false:null"
                  placeholder="NIP / NUP"
                  :disabled="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Must only consist of numbers-->
          <b-col md="6">
            <b-form-group>
              <label>Unit Kerja</label>
              <validation-provider
                #default="{ errors }"
                name="Unit Kerja"
              >
                <b-form-input
                  v-model="biodata.unit_kerja"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Unit Kerja"
                  :disabled="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Must match the specified regular expression : ^([0-9]+)$ - numbers only -->
          <b-col md="6">
            <b-form-group>
              <label>Masa Kerja</label>
              <validation-provider
                #default="{ errors }"
                name="Masa Kerja"
              >
                <b-form-input
                  v-model="biodata.masa_kerja"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Masa Kerja"
                  :disabled="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- <b-col md="6">
            <b-form-group>
              <label>Sisa Cuti</label>
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Sisa Cuti"
              >
                <b-form-input
                  v-model="numberRegx"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Sisa Cuti"
                  :disabled="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col> -->

        </b-row>
        <b-row class="mt-3">
          <!--  Only alphabetic characters-->
          <b-col md="6">
            <b-form-group>
              <label>Jenis Cuti</label>
              <validation-provider
                v-slot="{ errors }"
                rules="required"
                name="jenis cuti"
              >
                <v-select
                  :options="leaveOptions"
                  v-model="jenis_cuti_id"
                  :class="{'is-invalid': errors.length > 0}"
                  placeholder="Pilih Jenis Cuti"
                  :reduce="val => val.value"
                ></v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Attachment Field -->
          <b-col md="6" v-if="jenis_cuti_id && jenis_cuti_id != 7">
            <b-form-group>
              <label>Surat Keterangan (Wajib PDF)</label>
              <validation-provider
                v-slot="{ errors }"
                rules="required"
                name="Surat Keterangan"
              >
                <b-form-file
                  v-model="attachmentFile"
                  accept=".pdf"
                  placeholder="Pilih file PDF..."
                  drop-placeholder="Drop file di sini..."
                  @change="onAttachmentSelected"
                  :class="{'is-invalid': errors.length > 0}"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                <b-card-text v-if="uploadedFileName" class="mt-1 small text-success">
                  File terunggah: {{ uploadedFileName }}
                </b-card-text>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3">
            <b-form-group>
              <label>Tanggal Mulai Cuti</label>
              <validation-provider
                v-slot="{ errors }"
                rules="required"
                name="Tanggal Mulai Cuti"
              >
                <flat-pickr
                  v-model="tanggalMulaiCuti"
                  :config="dateConfig"
                  class="form-control"
                  :class="{ 'is-invalid': errors.length > 0 }"
                  placeholder="Pilih Tanggal Mulai Cuti"
                  @input="(val) => formatTanggalMulaiCuti(val)"
                ></flat-pickr>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <label>Tanggal Selesai Cuti</label>
              <validation-provider
                v-slot="{ errors }"
                rules="required"
                name="Tanggal Selesai Cuti"
              >
                <flat-pickr
                  v-model="tanggalSelesaiCuti"
                  :config="dateConfig"
                  class="form-control"
                  :class="{ 'is-invalid': errors.length > 0 }"
                  placeholder="Pilih Tanggal Selesai Cuti"
                  @input="(val) => formatTanggalSelesaiCuti(val)"
                ></flat-pickr>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <label>Lama Cuti</label>
              <validation-provider
                #default="{ errors }"
                name="Lama Cuti"
              >
                <b-form-input
                  v-model="lamaCuti"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Lama Cuti"
                  :readonly="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <label>Sisa Cuti</label>
              <validation-provider
                #default="{ errors }"
                name="Sisa Cuti"
              >
                <b-form-input
                  v-model="biodata.sisa_cuti"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Sisa Cuti"
                  :type="'number'"
                  :disabled="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>

          <!-- Length should not be less than the specified length : 3 -->
          <b-col md="6">
            <b-form-group>
              <label>Alasan Cuti</label>
              <validation-provider
                v-slot="{ errors }"
                rules="required"
                name="Alasan Cuti"
              >
                <b-form-textarea
                  v-model="alasanCuti"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Alasan Cuti"
                  rows="5"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label>Alamat Selama Cuti</label>
              <validation-provider
                v-slot="{ errors }"
                rules="required"
                name="Alamat Cuti"
              >
                <b-form-textarea
                  v-model="alamatCuti"
                  :state="errors.length > 0 ? false : null"
                  placeholder="alamat Cuti"
                  rows="5"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6" v-if="this.catatan != ''">
            <b-form-group>
              <label>Catatan Penolakan</label>
              <validation-provider
                v-slot="{ errors }"
                name="Catatan Penolakan"
              >
                <b-form-textarea
                  v-model="catatan"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Catatan Penolakan"
                  rows="5"
                  :readonly="true"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <!-- submit button -->
          <b-col cols="12">
            <b-button
              variant="primary"
              type="submit"
              @click.prevent="validationForm"
              :disabled="isLoading == 1"
            >
              Submit
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>

    <!-- <template #code>
      {{ codeType }}
    </template> -->
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BButton, BFormTextarea, BFormFile,
} from 'bootstrap-vue'
import {
  required, email, confirmed, url, between, alpha, integer, password, min, digits, alphaDash, length,
} from '@validations'
import { codeType } from './code'
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {
  getUser,
  getJenisCuti,
  postCuti,
  getUserPengaju,
  getDetailPengajuanCuti,
  perbaikanCuti,
  uploadFilePengajuan,
} from '@/connection-api/pengajuan-cuti/api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    vSelect,
    BFormTextarea,
    flatPickr,
    BFormFile,
  },
  data() {
    return {
      catatan: '',
      isLoading: 0,
      userData: {},
      biodata: {},
      name: '',
      passwordValue: '',
      passwordCon: '',
      emailValue: '',
      number: '',
      numberRange: '',
      numberRegx: '',
      URL: '',
      Alphabetic: '',
      digitValue: '',
      digitValue2: '',
      character: '',
      required,
      confirmed,
      password,
      email,
      min,
      integer,
      url,
      alpha,
      between,
      digits,
      length,
      alphaDash,
      codeType,
      uploadedFileName: "",
      attachmentFileRaw: null,
      jenis_cuti_id: null,
      leaveOptions: [],
      alasanCuti: "",
      tanggalMulaiCuti: null,
      tanggalSelesaiCuti: null,
      calculateMulai: null,
      calculateSelesai: null,
      dateConfig: {
        dateFormat: "d-m-Y"
      },
      lamaCuti: 0,
      alamatCuti: "",
      attachmentFile: null,
    }
  },
  mounted() {
    if(this.$route.params.uuid)
    {
      this.getAllDataUUID()
    } else {
      this.getAllData()
    }
  },
  methods: {
    getAllDataUUID() {
      getDetailPengajuanCuti(this.$route.params.uuid)
      .then(response => {
        if (response.data.success == true) {
          this.userData = response.data.data
          this.jenis_cuti_id =this.userData.jenis_cuti_id
          this.tanggalMulaiCuti =this.userData.tanggal_mulai_cuti
          this.tanggalSelesaiCuti = this.userData.tanggal_selesai_cuti
          this.lamaCuti = this.userData.lama_cuti
          this.alamatCuti = this.userData.alamat_cuti
          this.alasanCuti =this.userData.alasan_cuti
          this.catatan = this.userData.catatan_penolakan
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan E-Cuti',
              icon: 'EditIcon',
              variant: 'danger',
              text: 'Data User Tidak Ditemukan',
            },
          })
        }
      })
      .catch(error => console.log(error));
      //=======================================
      getUserPengaju(this.$route.params.uuid)
      .then(response => {
        if (response.data.success == true) {
          this.biodata = response.data.data
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan E-Cuti',
              icon: 'EditIcon',
              variant: 'danger',
              text: 'Data User Tidak Ditemukan',
            },
          })
        }
      })
      .catch(error => console.log(error));
      //=======================================
      getJenisCuti()
      .then(response => {
        if (response.data.success == true) {
          //gunakan response.data.data
          this.leaveOptions = response.data.data.map(item => ({
            label: item.nama,
            value: item.id,
          }));
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan E-Cuti',
              icon: 'EditIcon',
              variant: 'danger',
              text: 'Data Jenis Cuti Tidak Ditemukan',
            },
          })
        }
      })
      .catch(error => console.log(error));
      //=======================================
      
    },
    getAllData() {
      getUser()
      .then(response => {
        if (response.data.success == true) {
          this.biodata = response.data.data
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan E-Cuti',
              icon: 'EditIcon',
              variant: 'danger',
              text: 'Data User Tidak Ditemukan',
            },
          })
        }
      })
      .catch(error => console.log(error));
      //=======================================
      getJenisCuti()
      .then(response => {
        if (response.data.success == true) {
          //gunakan response.data.data
          this.leaveOptions = response.data.data.map(item => ({
            label: item.nama,
            value: item.id,
          }));
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan E-Cuti',
              icon: 'EditIcon',
              variant: 'danger',
              text: 'Data Jenis Cuti Tidak Ditemukan',
            },
          })
        }
      })
      .catch(error => console.log(error));
      //=======================================
      
    },
    async validationForm() {
      if(window.confirm('Apakah anda yakin?'))
      {
        
        this.$refs.simpleRules.validate().then(async success => {
          if (success) {
            this.isLoading = 1

            // 1. Upload attachment if exists
            if (this.attachmentFileRaw) {
              try {
                const uploadResp = await uploadFilePengajuan(this.attachmentFileRaw);
                if (uploadResp.data.success) {
                  this.userData.dokumen_id = uploadResp.data.data.id;
                } else {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Upload Gagal',
                      icon: 'AlertTriangleIcon',
                      variant: 'danger',
                      text: uploadResp.data.message,
                    },
                  });
                  this.isLoading = 0;
                  return;
                }
              } catch (error) {
                console.error(error);
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Error Upload',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                    text: 'Gagal mengunggah surat keterangan',
                  },
                });
                this.isLoading = 0;
                return;
              }
            }

            // 2. Prepare user data
            this.userData.jenis_cuti_id = this.jenis_cuti_id
            this.userData.tanggal_mulai_cuti = this.tanggalMulaiCuti
            this.userData.tanggal_selesai_cuti = this.tanggalSelesaiCuti
            this.userData.lama_cuti = this.lamaCuti
            this.userData.alamat_cuti = this.alamatCuti
            this.userData.alasan_cuti = this.alasanCuti
  
            // 3. Submit cuti request
            if(this.$route.params.uuid)
            {
              perbaikanCuti(this.userData)
                .then(response => {
                  if (response.data.success == true) {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Pengajuan Cuti',
                        icon: 'EditIcon',
                        variant: 'success',
                        text: 'Data berhasil disimpan',
                      },
                      duration: 5000,
                    })
                    this.isLoading = 0
                    setTimeout(() => {
                    this.$router.push({ 
                      name: 'daftar-list-cuti', 
                      // params: { uuid: response.data.data.uuid } 
                    })
                  }, 1000);
                  } else {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Pengajuan Cuti',
                        icon: 'EditIcon',
                        variant: 'danger',
                        text: 'Data gagal disimpan',
                      },
                    })
                    this.isLoading = 0
                  }
                })
                .catch(error => console.log(error));
            } else {
              postCuti(this.userData)
                .then(response => {
                  if (response.data.success == true) {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Pengajuan Cuti',
                        icon: 'EditIcon',
                        variant: 'success',
                        text: 'Data berhasil disimpan',
                      },
                      duration: 5000,
                    })
                    this.isLoading = 0
                    setTimeout(() => {
                    this.$router.push({ 
                      name: 'daftar-list-cuti', 
                      // params: { uuid: response.data.data.uuid } 
                    })
                  }, 1000);
                  } else {
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Pengajuan Cuti',
                        icon: 'EditIcon',
                        variant: 'danger',
                        text: response.data.message,
                      },
                    })
                    this.isLoading = 0
                  }
                })
                .catch(error => console.log(error));
            }
          }
        })
      }
    },
    formatTanggalMulaiCuti(selectedDates) {
      if (selectedDates.length) {
        this.calculateMulai = this.formatDate(selectedDates[0]);
        this.calculateLamaCuti();
      }
    },
    formatTanggalSelesaiCuti(selectedDates) {
      if (selectedDates.length) {
        this.calculateSelesai = this.formatDate(selectedDates[0]);
        this.calculateLamaCuti();
      }
    },
    formatDate(date) {
      const d = new Date(date);
      const day = (`0${d.getDate()}`).slice(-2);
      const month = (`0${d.getMonth() + 1}`).slice(-2);
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    },
    calculateLamaCuti() {
      if (this.tanggalMulaiCuti && this.tanggalSelesaiCuti) {
        const mulai = new Date(this.parseDate(this.tanggalMulaiCuti));
        const selesai = new Date(this.parseDate(this.tanggalSelesaiCuti));
        const diffTime = selesai - mulai;
        this.lamaCuti = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // Tambah 1 hari untuk mengikutsertakan tanggal mulai cuti
      } else {
        this.lamaCuti = 0;
      }
    },
    parseDate(dateString) {
      const parts = dateString.split('-');
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    },
    onAttachmentSelected(event) {
      const file = event.target.files[0];
      if (file) {
        if (file.type !== 'application/pdf') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error File',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: 'Hanya file PDF yang diperbolehkan',
            },
          });
          this.attachmentFile = null;
          this.attachmentFileRaw = null;
          return;
        }

        this.attachmentFileRaw = file;
        this.uploadedFileName = file.name;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'File Terpilih',
            icon: 'CheckIcon',
            variant: 'info',
            text: 'File siap diunggah saat Anda mengirim form',
          },
        });
      }
    },
  },
}
</script>
